/**
 * The maximum number of items that can be pinned to the MRU.
 */ export const PinItemLimit = 50;
/**
 * The maximum number of items that can be in the MRU.
 */ export const MruItemLimit = 100;
/**
 * The maximum number of items that can be pinned per app type.
 */ export const MaxPinItemLimit = 100;
/**
 * The maximum number of recent orgs for which plans needed to be fetched.
 */ export const MaxRecentOrgs = 4;
